<template>
    <div
        :class="
            'admin site-width ' +
            (getMode === 'cancelcancer' ? 'single' : 'single')
        ">
        <Seo :title="$t('admin')" canonical="/admin" />

        <div class="menu-headline-distance" />
        <SiteHeadline
            is-main
            headline="Event"
            message="Cancel Cancer Berlinale 2026" />
        <div class="headline-message-distance" />

        <div class="admin-struct">
            <div v-if="authorized">
                <div class="uk-margin-top" />

                <div class="uk-text-center" v-if="loading">
                    <span uk-spinner />
                </div>
                <div v-else>
                    <div
                        class="uk-card uk-card-alternative uk-dark-card-hovered uk-card-body uk-text-center">
                        <div v-if="error">
                            <h2 class="uk-text-danger">Ungültiges Ticket</h2>

                            <br />
                            Das eingescannte Ticket ist nicht gültig.
                        </div>
                        <div v-else>
                            <h2 class="uk-text-success">
                                <Icon icon="check" :ratio="3" />
                                <br />
                                Gültiges Ticket
                                <div v-if="invite.partner">
                                    <Icon icon="users" :ratio="2" /> Mit
                                    Begleitung
                                </div>
                            </h2>
                            <div class="uk-text-large">
                                {{
                                    $t(invite.salutation) +
                                    ' ' +
                                    (invite.forename ?? '') +
                                    ' ' +
                                    (invite.surname ?? '')
                                }}
                            </div>
                            <div class="uk-margin-small-top">
                                {{ invite.email }}
                            </div>

                            <hr class="uk-margin-medium-top uk-margin-bottom" />
                            <span v-on:click="actionBack()">
                                <Button isLarge mode="default">
                                    Zurück zur Übersicht
                                </Button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="last-section-distance" />
    </div>
</template>

<script>
import Seo from '../components/Seo';
import SiteHeadline from '../components/SiteHeadline';
import axios from 'axios';
import Icon from '@/components/Icon.vue';
import Button from '@/components/Button.vue';

export default {
    name: 'AdminTicket',
    components: {
        Button,
        Icon,
        SiteHeadline,
        Seo,
    },
    data() {
        return {
            password: '',
            authorized: false,
            loginStatus: null,

            invite: {},
            loading: true,
            error: null,
        };
    },
    created() {
        axios.defaults.timeout = this.apiTimeout;

        let password = this.$cookie.get('password');

        if (!password) {
            password = this.$route.query.token;
        }

        if (!password) {
            password = this.$route.query.password;
        }

        if (password) {
            this.password = password;
            this.login();
        } else {
            this.routeTo();
        }
    },
    methods: {
        actionBack() {
            this.routeTo('admin/berlinale');
        },
        convertDate(date) {
            let parsedDate = new Date(date);
            parsedDate.setHours(parsedDate.getHours() + 1);

            if (isNaN(parsedDate)) {
                return date;
            }

            let dateLang = 'en-US';
            if (this.$i18n.locale === 'de') {
                dateLang = 'de-DE';
            }

            return parsedDate
                .toLocaleDateString(dateLang, {
                    weekday: 'long',
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false,
                })
                .replace(/[^ -~]/g, '');
        },
        getInvite() {
            let http = axios.create();
            http.get(
                this.getBaseUrl +
                    '/api/invites/' +
                    this.$route.params.id +
                    '/verify'
            )
                .then((response) => {
                    this.invite = response.data;
                    this.loading = false;
                })
                .catch((e) => {
                    this.error = e;
                    this.loading = false;
                });
        },
        login() {
            axios.defaults.headers.common['password'] = this.password;

            let http = axios.create();
            http.post(this.getBaseUrl + '/api/login/inspector')
                .then(() => {
                    this.$cookie.set('password', this.password, 30);
                    this.authorized = true;
                    this.loginStatus = 200;

                    this.getInvite();
                })
                .catch(() => {
                    this.routeTo();
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.uk-button {
    text-transform: initial !important;
}

.admin-struct {
    min-height: calc(100vh - 70px - 70px - 177px - 279px);
}

.uk-table-striped > tr:nth-of-type(odd),
.uk-table-striped tbody tr:nth-of-type(odd) {
    background: $alternative-color !important;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
}

.uk-table-hover > tr:hover,
.uk-table-hover tbody tr:hover {
    background: $alternative-color !important;
}

.uk-input {
    color: #ddd !important;
}

.uk-switcher {
    margin-top: 25px;
}

.uk-tab > * > a {
    text-transform: initial !important;
    font-size: 16px;
    font-weight: 400;
    border-color: transparent;
}

.customer-logo {
    max-width: 200px !important;
    max-height: 40px !important;
}

.video-item {
    height: 200px;
    margin-top: 5px;
}

.small {
    font-size: 15px;
}
</style>
